module.exports = __webpack_public_path__ + "static/img/zjgn04.787583e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/zjgn04.jpg
// module id = 1427
// module chunks = 0